<template>
  <main class="sm:px-12 px-10">
    <transition-group
      enter-class="opacity-0"
      enter-active-class="transition ease-out duration-200"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="transition ease-in duration-75"
      leave-to-class="opacity-0"
      mode="out-in"
    >
      <ActionPanel key="1" v-show="!tokenVerified" class="sm:mx-24 mx-0 mt-24">
        <ActionPanelHeader>
          <h3 class="font-bold">Resetting your password</h3>
        </ActionPanelHeader>
        <ActionPanelBody>Please wait while we verify your token.</ActionPanelBody>
        <ActionPanelFooter>
        </ActionPanelFooter>
      </ActionPanel>
      <div v-show="tokenVerified" key="2" class="flex justify-center sm:mx-24 mx-0 mt-24">
        <form @submit.prevent class="w-64">
          <b-field label="New Password">
            <b-input
              v-model="password"
              type="password"
              password-reveal
            />
          </b-field>
          <b-field label="Confirm Password">
            <b-input
              v-model="confirmPassword"
              type="password"
              password-reveal
            />
          </b-field>
          <b-button
            type="is-primary"
            class="mt-8"
            expanded
            @click="resetPassword"
          >
            Reset password
        </b-button>
        </form>
      </div>
    </transition-group>
  </main>
</template>

<script>
import { ActionPanel, ActionPanelHeader, ActionPanelBody, ActionPanelFooter } from '@/components/action-panel'

export default {
  name: 'ResetPassword',
  components: {
    ActionPanel,
    ActionPanelHeader,
    ActionPanelBody,
    ActionPanelFooter
  },
  data () {
    return {
      tokenVerified: false,
      password: '',
      confirmPassword: ''
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    }
  },
  mounted () {
    setTimeout(() => {
      // Route to verify token here
      this.tokenVerified = true
    }, 2000)
  },
  methods: {
    async resetPassword () {
      try {
        const payload = {
          password: this.password,
          confirmPassword: this.confirmPassword,
          token: this.token
        }
        await this.$store.dispatch('auth/resetPassword', payload)
        this.$router.push('/admin/login')
      } catch (error) {
        this.$logger.error('Error resetting password', error)
        this.$sentry.captureException(error)
      }
    }
  }

}
</script>
